import { useMsal } from "@azure/msal-react";
import { acquireToken } from "./acquireToken";

export function useGraphToken() {
  const { instance, accounts } = useMsal();

  return async function getToken(): Promise<string> {
    const account = accounts[0] ?? instance.getActiveAccount();
    if (!account) throw new Error("Kein angemeldeter Microsoft-365-Account");
    return (await acquireToken(instance, account)).accessToken;
  };
}
